import AppContext from 'app/appContext'
import { matchPath } from 'app/router/Routes'
import { useContext, useEffect, useMemo, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'

export function usePreviousRoute () {
  const appContext = useContext(AppContext)
  const location = useLocation()
  const prevLocationRef = useRef(location)
  const routes = useMemo(() => {
    return appContext?.routes ?? []
  }, [appContext?.routes])

  const [previous, setPrevious] = useState({
    path: null,
    name: null
  })

  useEffect(() => {
    setPrevious({
      path: prevLocationRef.current.pathname,
      name: routes.find(r => matchPath(r.path, prevLocationRef.current.pathname))?.label ?? null
    })
    prevLocationRef.current = location
  }, [location, routes])

  return previous
}
